module.exports = __webpack_public_path__ + "img/主营业务_能源系统集成02.9128f2f5.png";